import { css } from 'styled-components/macro';

export const SubTextStyle = css`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #2e4063;
  margin-bottom: 32px;
  margin-right: 64px;
`;

export const LinkContainerStyle = css`
  display: flex;
`;

export const WikipediaLinkStyle = css`
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  margin-right: 8px;
  color: #2e4063;

  display: flex;
  gap: 8px;
`;
